const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20deep%20charcoal%20artistic%20composition%20with%20smooth%20flowing%20gradients%2C%20elegant%20modern%20minimal%20design%20representing%20premium%20curated%20entertainment%20content%2C%20soft%20luminous%20accents%20on%20dark%20background%2C%20sophisticated%20editorial%20aesthetic%2C%20clean%20geometric%20overlay%20with%20subtle%20texture&width=800&height=500&seq=card-rv-01&orientation=landscape',
    tag: '蜜桃视频',
    title: '蜜桃视频独家推荐 · 月度精选合集',
    desc: '每月精选蜜桃视频最受关注的独家内容，涵盖多类型热门专题，高清画质流畅观看，VIP会员免费直享全部推荐。',
    meta: '更新于 2 小时前 · 128 部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20deep%20burgundy%20and%20golden%20artistic%20composition%20with%20rich%20layered%20textures%2C%20elegant%20modern%20digital%20art%20style%2C%20warm%20luminous%20highlights%20on%20dark%20elegant%20background%2C%20sophisticated%20curated%20entertainment%20aesthetic%2C%20clean%20minimal%20lines%20with%20luxurious%20feel&width=800&height=500&seq=card-rv-02&orientation=landscape',
    tag: '红桃视频',
    title: '红桃视频特色专题 · 编辑精选推荐',
    desc: '红桃视频编辑团队精心筛选的优质内容专题，从海量资源中挑选最具代表性的精彩视频，呈现独特观影视角。',
    meta: '更新于 5 小时前 · 96 部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20amber%20and%20charcoal%20artistic%20composition%20with%20dynamic%20curved%20shapes%2C%20modern%20minimal%20design%20suggesting%20streaming%20entertainment%20and%20video%20content%2C%20soft%20golden%20glow%20on%20deep%20dark%20background%2C%20elegant%20editorial%20aesthetic%20with%20smooth%20gradients&width=800&height=500&seq=card-rv-03&orientation=landscape',
    tag: '香蕉视频',
    title: '香蕉视频VIP免费频道 · 热门合辑',
    desc: '香蕉视频VIP会员专属频道内容免费开放，汇集全站热门合辑与高分作品，高清流畅播放体验，每日滚动更新。',
    meta: '更新于 8 小时前 · 215 部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20rose%20gold%20and%20dark%20slate%20artistic%20composition%20with%20soft%20flowing%20organic%20shapes%2C%20elegant%20modern%20minimal%20design%20evoking%20premium%20curated%20content%2C%20warm%20delicate%20highlights%20on%20deep%20background%2C%20sophisticated%20editorial%20photography%20style&width=800&height=500&seq=card-rv-04&orientation=landscape',
    tag: '樱花视频',
    title: '樱花视频特色频道 · 新番速递',
    desc: '樱花视频频道最新番剧与热门内容一站式速递，同步更新最受关注的新番资源，让你不错过任何精彩瞬间。',
    meta: '更新于 12 小时前 · 87 部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20bronze%20and%20charcoal%20artistic%20composition%20with%20elegant%20angular%20geometric%20patterns%2C%20modern%20minimal%20design%20representing%20trending%20entertainment%20content%2C%20rich%20golden%20accents%20on%20deep%20dark%20canvas%2C%20sophisticated%20editorial%20aesthetic%20with%20luxurious%20texture&width=800&height=500&seq=card-rv-05&orientation=landscape',
    tag: '排行榜',
    title: '本周热播排行榜 · TOP 50 精选',
    desc: '根据全站观看热度、收藏量与用户评分综合计算的热播排行榜，每周更新一次，帮你快速锁定最受欢迎的好视频。',
    meta: '更新于 1 天前 · 50 部上榜',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20copper%20and%20dark%20obsidian%20artistic%20composition%20with%20flowing%20wave%20patterns%2C%20elegant%20modern%20digital%20art%20style%2C%20warm%20metallic%20highlights%20on%20deep%20black%20background%2C%20sophisticated%20premium%20entertainment%20aesthetic%2C%20clean%20smooth%20gradients%20with%20refined%20atmosphere&width=800&height=500&seq=card-rv-06&orientation=landscape',
    tag: '独家专题',
    title: '日皮视频独家策划 · 深度专题系列',
    desc: '由日皮视频团队独家策划的深度专题系列，围绕特定主题整合多频道优质内容，为你带来沉浸式的观影旅程。',
    meta: '更新于 2 天前 · 36 部精选',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">
            从蜜桃视频到樱花视频，六大精选频道为你呈现不可错过的热门内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {cards.map((card) => (
            <article
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500/85 text-background-950 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-semibold text-foreground-100 mb-2 font-heading line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-time-line"></i>
                  <span>{card.meta}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}